import { buildBaseEventData } from './commonAnalytics';
import { Utils } from './sendAnalyticsEvent';

export const trackClickEvent = (eventName, { omsId, productName, brand }, eventType = 'stash') => {
  const clickEvent = buildBaseEventData(eventType, eventName);
  clickEvent.eventMode = 'stash';
  let item = [{
    index: '',
    omsId,
  }];
  if (omsId) {
    item = [{
      productInfo: {
        sku: `${omsId}`,
        productName,
        manufacturer: `${brand}`,
        productType: 'merchandise',
      },
    }];
  }
  clickEvent.stash = {
    pageType: 'pip',
    sharedSection: '',
    section: '',
    component: '',
    target: 'atc',
    item,
  };

  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackClick = (eventName, { omsId, productName, brand }, eventType) => {
  trackClickEvent(eventName, { omsId, productName, brand }, eventType);
};

export const trackSaveDesign = () => {
  const clickEvent = buildBaseEventData('button submission', 'design save');
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackUpdateDesign = (omsId) => {
  const clickEvent = buildBaseEventData('button submission', 'design item config update');
  clickEvent.item = [{
    productInfo: {
      sku: `${omsId}`,
    },
  }];
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackSaveContinueDesign = () => {
  const clickEvent = buildBaseEventData('installation services and repair', 'form start');
  clickEvent.form = {
    formType: 'installation services and repair',
    formName: 'custom countertops installation',
  };
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackDesignPurchaseButtonEvent = ({ eventName, ButtonTitle }) => {
  const clickEvent = buildBaseEventData('button submission', `${eventName} : ${ButtonTitle}`);
  Utils.sendAnalyticsEvent(clickEvent);
};
